import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';
import DBullets from '../../pieces/DBullets';
import DImage from '../../pieces/DImage';
import workflowImage from './WorkflowImage_1.jpg';

export default function FlowCreator() {

    return (
        <div>
            <DHeader>Creating a Flow</DHeader>
       
            <DText>
            The Flow class, imported from Laeyerz, is the core workflow model used to define and execute workflows. While creating a Flow object, a name that identifies the workflow is provided as an argument. The resulting Flow can execute steps sequentially, in parallel, or through more complex graph-based execution paths, depending on how the workflow is defined.
            </DText>
           

            <DCode>
              {`from laeyerz.flow.Flow import Flow

simple_flow = Flow("Flow 1") `}
            </DCode>

           <DText>
           Once you initialize a Flow, you need to add
           </DText>

           <DBullets>
         * Nodes you have created,
 *  Edges for the flow of Control
* Data Connections to indicate how data connects across Nodes
* Outputs to indicate the parameters the workflow returns

           </DBullets>


<DText>
Once these are defined, you can run the Flow.
       
</DText>
   
            
       
        </div>
    )
}